import React from 'react';
import { Hero } from './components/Hero';
import { Empathy } from './components/Empathy';
import { Pillars } from './components/Pillars';
import { Method } from './components/Method';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { RecentBookingToast } from './components/RecentBookingToast';
export function App() {
  return <div className="min-h-screen bg-white selection:bg-brand-amber/30 selection:text-brand-navy" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Empathy data-id="element-3" />
        <Pillars data-id="element-4" />
        <Method data-id="element-5" />
        <Testimonials data-id="element-6" />
        <FAQ data-id="element-7" />
        <CTA data-id="element-8" />
      </main>

      <Footer data-id="element-9" />
      <RecentBookingToast data-id="element-10" />
    </div>;
}